// extracted by mini-css-extract-plugin
export default {"container":"StudentList_container__Nn8-0","divider":"StudentList_divider__Lw5x5","scroll-wrapper":"StudentList_scroll-wrapper__MZitC","no_data_row":"StudentList_no_data_row__hOEbr"};